import React, { useEffect, useState } from "react";
import { MDBIcon } from "mdbreact";
import {
  Card,
  CardHeader,
  CardBody,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Col,
  Label,
  CardFooter,
  Button,
  Media,
  FormGroup,
  Input,
} from "reactstrap";
import ListItemText from '@material-ui/core/ListItemText';
import axios from "utils/api";
import pageShowing from "utils/pageShowing";
import { ExportToCsv } from 'export-to-csv';
import moment from 'moment';

const searchIcon = {
  position: "absolute",
  zIndex: 2,
  display: "block",
  width: "2.375rem",
  height: "2.375rem",
  lineHeight: "4rem",
  paddingLeft: "2.375rem",
  textAlign: "center",
  color: "#aaa"
};

const searchInput = {
  marginLeft: "20px",
  marginTop: "10px",
  paddingLeft: "3rem",
  width: "100%"
};

const submitButton = {
  marginLeft: "25px",
  marginTop: "10px",
  marginRight: "20px",
  height: "46px"
};

const AuditLogs = () => {
  const authSession = JSON.parse(localStorage.getItem('auth'));
  const [auditLogs, setAuditLogs] =  useState({ dataRows : [], dataCount : null, currentPage : 1 });
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState({ currentPage: 1, pageSize : 10, totalCount: 0 });
  const pageNumbers = [];

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      getAuditLogs(page.currentPage, page.pageSize);

      var auditlog = { 
        moduleName: `Audit Logs`,
        accountId: authSession.merchantGroupCode,
        username: authSession.username,
        actionsTaken: `Viewed audit logs`
      };
  
      axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
    }

    return () => {
      mounted = false;
    };
  },[]);

  const handlePageChange = (event) => {
    if (!(event.value < 1 || event.value > pageNumbers[pageNumbers.length - 1]) ) {
      getAuditLogs(event.value, page.pageSize);
    }
  };

  const handleSearchChange = (event) => {
    event.preventDefault();

    setSearchText(event.target.value);

    setPage(page => ({...page}));
  };

  const handleSearch = (event) => {
    event.preventDefault();

    getAuditLogs(1, page.pageSize);
  };

  const getAuditLogs = (currentPage, pageSize) => {
    const isParentMerchant = authSession.username === 'admin';

    axios.post(`/auditlog/getfilteredlogs?accountId=${authSession.merchantGroupCode}&username=${authSession.username}&isParentMerchant=${isParentMerchant}&searchValue=${searchText}&currentPage=${currentPage}&pageSize=${pageSize}`)
      .then(response => {
        setAuditLogs({
          dataRows : response.data.auditLogs,
          dataCount : response.data.totalItems,
          currentPage : currentPage
        });

        setPage(page => ({
          ...page,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount : response.data.totalItems
        }));
      }).catch(() => { 
        console.log('There is a problem fetching audit logs. Please try again later.');
      });
  };

  const renderTable = () => {
    return auditLogs.dataRows.map((auditLog) => {
      return (
        <tr key={auditLog.id}>
          <th>
            <Media className="align-items-center">
              <a
                className="avatar rounded-circle mr-3"
                href="#pablo"
                onClick={e => e.preventDefault()}
              >
                <img
                  alt="..."
                  src={require("assets/img/theme/audit_log_avatar.png")}
                />
              </a>
              <Media>
                <ListItemText 
                  primary={auditLog.moduleName} 
                  secondary={`Date & Time: ${moment(auditLog.dateCreated).format("YYYY-MM-DD hh:mm:ss A")} `} 
                />
              </Media>
            </Media>
          </th>
          <td>{auditLog.userName}</td>
          <td>{auditLog.actionsTaken}</td>
          <td>{auditLog.ipAddress}</td>
        </tr>
      );
    });
  };

  const renderPageNumbers = () => { 
    if (page.totalCount !== null) {
      let totalPages = Math.ceil(page.totalCount / page.pageSize);

      if (totalPages > 10) {
        let maxPage = 10;
        let minPage = 1;
        if (totalPages >= maxPage) {
          if (auditLogs.currentPage >= maxPage) {
            maxPage = auditLogs.currentPage + 2;
            minPage = auditLogs.currentPage - 2;
          }

          if (minPage < 1)
            minPage = 1;

          if (maxPage >= totalPages)
            maxPage = totalPages;

          if ((maxPage - minPage) < 9)
          minPage = maxPage - 9;

          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
        else {
          if (minPage < 1)
            minPage = 1;
          for (let i = minPage; i <= maxPage; i++) {
            pageNumbers.push(i)
          }
        }
      }
      else {
        for (let i = 1; i <= totalPages; i++) {
          pageNumbers.push(i)
        }
      }
    }

    return pageNumbers.map(number => {
      let classes = auditLogs.currentPage === number ? 'active' : '';

      return (
        <PaginationItem className={classes} key={number}>
          <PaginationLink onClick={(e, val) => handlePageChange({ value: number})}> {number} </PaginationLink>
        </PaginationItem>
      );
    });
  };

  const exportToCsv = () => {
    axios.post(`/auditlog/getlogs?accountId=${authSession.merchantGroupCode}`)
      .then(response => {
        const options = { 
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true, 
          showTitle: true,
          title: `Audit Logs`,
          useTextFile: false,
          useBom: true,
          useKeysAsHeaders: false,
          headers: ['Module Name', 'Username', 'Actions Taken', 'Date Created'],
          filename: `Audit Logs`
        };

        var auditlog = { 
          moduleName: `Audit Logs`,
          accountId: authSession.merchantGroupCode,
          username: authSession.username,
          actionsTaken: `Downloaded logs to excel (.csv) format`
        };
    
        axios.post('auditlog/add', { auditlog: auditlog }).then(() => { });
        
        new ExportToCsv(options).generateCsv(response.data.auditLogs);
        
      }).catch(() => { 
        console.log('There is a problem generating the audit logs. Please try again later.');
      });
  }

  return (
    <>
     <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="page-header">
        <h1>Audit Logs</h1>
        <h3>Lists of activity or transaction logs recorded in the system.</h3>
        <p>
          <MDBIcon icon="link" className="text-green" fixed /> 
          <a className="text-green" href="/admin/index"> Dashboard</a> / Audit Logs 
        </p>
      </div>
      <Container>
        <Row>
          <div className="col">
            <Row>
              <Col md="12" xs="12">
                <Card className="card-stats mb-4 mb-xl-0 shadow">
                  <CardHeader className="border-0">
                      <Row>
                        <Col>
                        <h3 className="mb-0">Audit Logs ({auditLogs.dataCount?.toLocaleString()})</h3>
                        </Col>
                        <Col>
                          <div style={{float: 'right', marginTop: '-20px'}}>
                            <Button type="submit" outline style={submitButton} onClick={event => exportToCsv(event)} color="info" hidden={authSession.username !== 'admin'}>
                              <MDBIcon icon="server"/> Export to excel (.csv) format</Button>
                          </div>
                        </Col>
                      </Row>
                  </CardHeader>
                  <hr className="mt--2 divider" />
                  <CardBody>
                    <Row className="search-container">
                      <Col sm="12">
                        <div>
                          <FormGroup>  
                            <form className="d-flex">
                              <div className="form-group has-search w-100">
                                <span className="fa fa-search form-control-feedback" style={searchIcon}></span>
                                <Input 
                                  className="form-control me-2"
                                  style={searchInput}
                                  type="search" 
                                  placeholder="Search audit logs here..."
                                  aria-label="Search"
                                  name="searchValue"
                                  onChange={event => handleSearchChange(event)}
                                  onKeyPress={event => { if (event.key === "Enter") { handleSearch(event) }}}
                                  autoComplete="off">
                                </Input>
                              </div>
                              <Button type="submit" style={submitButton} onClick={event => handleSearch(event)} color="info">SEARCH</Button>
                            </form>
                          </FormGroup>
                        </div >
                      </Col>
                    </Row>
                    <Table className="align-items-center table-flush" responsive>
                      <thead className="thead-light">
                        <tr>
                          <th rowSpan="2">Module Name</th>
                          <th rowSpan="2">Username</th>
                          <th rowSpan="2">Actions Taken</th>
                        </tr>
                      </thead>
                      <tbody>
                        { auditLogs.dataCount !== 0
                          ?
                            renderTable()
                          :
                            <td colSpan="7" style={{textAlign: 'center'}}>
                              <Label size="sm" className="mr-sm-2"  >
                                  <i>
                                    <MDBIcon icon="exclamation-triangle" /> No available audit logs yet.
                                  </i> 
                                </Label>
                            </td>
                        }
                      </tbody>
                    </Table>
                    <CardFooter className="py-4">
                      <Row className="mt-0" hidden={!(Math.ceil(page.totalCount / page.pageSize) > 1)}>
                        <Col xl="6" l="6">
                          {pageShowing(page.totalCount, page.pageSize, page.currentPage)}
                        </Col>
                        <Col  xl="6">
                          <Pagination  className="pagination justify-content-end mb-0" listClassName="justify-content-end mb-0">
                            <PaginationItem>
                              <PaginationLink
                                onClick={() => handlePageChange({ value: (page.currentPage - 1)})}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-left" />
                                <span className="sr-only">Previous</span>
                              </PaginationLink>
                            </PaginationItem>
                            { renderPageNumbers()}
                            <PaginationItem>
                              <PaginationLink
                                onClick={() => handlePageChange({ value: (page.currentPage + 1)})}
                                tabIndex="-1"
                              >
                                <i className="fas fa-angle-right" />
                                <span className="sr-only">Next</span>
                              </PaginationLink>
                            </PaginationItem>
                          </Pagination>
                        </Col>
                      </Row>
                    </CardFooter>
                  </CardBody>              
                </Card>
              </Col>
            </Row>
          </div>
        </Row>
      </Container>
    </div>
    </>
  );
}

export default AuditLogs;
